<template>
  <div class="pa-login-box-content">
    <LoginBoxForms v-if="openType === 'form'" />
    <LoginLoadingBox v-if="openType === 'loading'" />
  </div>
</template>
<script>
import LoginBoxForms from '@/components/FrontParts/LoginModal/LoginBox/LoginForms.vue'
import LoginLoadingBox from '@/components/FrontParts/LoginModal/LoginBox/LoginLoadingBox.vue'

export default {
  name        : 'LoginBoxContent',
  components  : {
    LoginBoxForms,
    LoginLoadingBox
  },
  data(){
    return {
      openType  : 'form',
    };
  },
  mounted(){
    const vm = this;

    vm.$on('changeLoginContentBox', (type) => {
      vm.openType = type;
    });

    // setTimeout(() => {
    //   vm.$emit('changeLoginContentBox', 'loading');
    // }, 5000);
  }
}
</script>
<style lang="scss">
@import "~bulma/sass/utilities/_all";

div.pa-login-box-content{
}
</style>
